import { interfaces } from '@daas-consulting/core-cross-interfaces';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { Observable } from 'rxjs';

export interface RemitosService {
  getAll$(
    criteria: interfaces.CriteriaRequest
  ): Observable<interfaces.PagedList<models.RemitoListItemModel>>;
  get$(remitoId: string): Observable<models.detailPreview.ItemView>;
  getPrintData$(remitoId: string): Observable<models.print.PrintDataView>;
  getFormData$(): Observable<models.FormData>;
  save$(remito: models.RemitoFormModel): Observable<void>;

  // Custom methods for Remito specific workflow
  getAvailablePrescriptions$(
    institutionId: string
  ): Observable<models.AvailablePrescriptionModel[]>;
  getActivePurchaseOrders$(
    institutionId: string
  ): Observable<models.PurchaseOrderFormData[]>;
  emit$(remitoId: string): Observable<void>;
  cancel$(remitoId: string, reason: string): Observable<void>;
  print$(remitoId: string): Observable<void>;
}

export const RemitosServiceId = 'RemitosServiceId';
